import { AchEnrollmentStatus } from '@ocx/graphql';

const incompleteAchEnrollmentStatuses = [
  AchEnrollmentStatus.PendingEnrollment,
  AchEnrollmentStatus.Rejected,
  AchEnrollmentStatus.Expired,
  AchEnrollmentStatus.Suspended,
  AchEnrollmentStatus.Hold,
  AchEnrollmentStatus.WaitingApproval,
];

export const isEnrollmentIncomplete = (status: AchEnrollmentStatus | null | undefined): boolean => {
  if (!status) {
    return false;
  }

  return incompleteAchEnrollmentStatuses.includes(status);
};

const completeAchEnrollmentStatuses = [AchEnrollmentStatus.Active];

export const isEnrollmentCompleted = (status: AchEnrollmentStatus | null | undefined): boolean => {
  if (!status) {
    return false;
  }

  return completeAchEnrollmentStatuses.includes(status);
};
